import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`v1/api/cronlogs?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`v1/api/cronlogs/${id}`, { params });
}

export async function create(body) {
  return request(`v1/api/cronlogs`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`v1/api/cronlogs/${id}`, {
    method: 'POST',
    body,
  });
}